/*@ngInject*/
const DeleteFormSummaryInstanceRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.deleteFormSummaryRow = function (formIds) {
        let url = '/rest/Form',
            config = {
                params: {
                    formId: formIds
                }
            };
        return this.delete(url, config);
    };
};

angular.module('umFormViewer')
    .service('deleteFormSummaryInstanceRepository', DeleteFormSummaryInstanceRepository);
